// extracted by mini-css-extract-plugin
module.exports = {"clipboard":"vKiLS","clipboardVertical":"_1IJEV","formControl":"_3k_f9","formControlVertical":"_2dKP3","button":"_3qFb2","buttonVertical":"_3F0yZ"};